import React, { HTMLAttributes } from 'react';
import IconButton from '../IconButton/IconButton';

interface IProperties {
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
}

const PlayButton = ({ onClick }: IProperties) => {
  return (
    <IconButton
      className=" p-2 bg-theme-green text-theme-black outline-offset-[-1px] outline-none hover:outline-theme-light-green hover:outline hover:bg-theme-light-green"
      iconClassName=" text-[2.5rem]"
      icon="play_arrow"
      onClick={onClick}
    />
  );
};

export default PlayButton;
